import React, { Component } from 'react';
import { func } from "prop-types";
import './TimesheetEntry.css';

class TimesheetOvertime extends Component {
  static PropTypes = {
    totalsHandler: func
  }

  render() {
    return (
      <tr className="timesheetEntryTotals">
        <td colSpan="2">OverTime:</td>
        {
          Array.from(this.props.totalsHandler().values()).map((totalHours, i) => {
            return <td key={i} className="timesheetEntryDataWD">{totalHours > 8 ? totalHours - 8 : 0}</td>;
          })
        }
      </tr>
    );
  }
}

export default TimesheetOvertime;


// WEBPACK FOOTER //
// ./src/components/main/timesheet/_common/TimesheetOvertime.js